export default "__VITE_ASSET__61a1b7d9__"